import type { Document } from './document.types'

export enum ControlStatus {
  Undecided = -1,
  NotApplicable = 0,
  DocumentListPending = 1,
  DocumentsPending = 2,
  DocumentsReadyForAudit = 3,
  DocumentsPassedAudit = 4,
}
export type ControlItemDefinition = {
  id: number
  parentId: number
  isoStandard: 9001 | 27001
  code: string
  title: string
  titleId: string
  description?: string
  descriptionId?: string
  implementationGuide?: string
  implementationGuideId?: string
  sortOrder: number
  createTs: string | Date
}
export type ControlItemState = {
  id: number
  // biome-ignore lint/suspicious/noExplicitAny: temporarily set to dummy for now
  meta: any
  justification?: string
  status: ControlStatus
  sortOrder: number
  createTs: string | Date
  updateTs: string | Date
}
export type ControlItem = ControlItemDefinition &
  ControlItemState & {
    controlDocumentMap?: {
      controlId: number
      documentId: number
    }[]
    documents?: Document[]
  }
